module.exports = __webpack_public_path__ + "media/images/flags/32/Maldives-21784b4fe06e415e86d1a4fe07834b5f.png";